import { useContext } from "react";
import { ConsentContext } from "./ConsentProvider";

/**
 * Hook pre prístup k stavu súhlasu a akciám z ľubovoľného komponentu.
 *
 * Použitie:
 *   const { consent, acceptAll, rejectAll, openSettings } = useConsent();
 *
 * @returns {ConsentContextValue}
 */
export function useConsent() {
  const ctx = useContext(ConsentContext);
  if (!ctx) {
    throw new Error("useConsent musí byť použitý vnútri <ConsentProvider>");
  }
  return ctx;
}
